<template>
  <b-modal
    :ok-disabled="disabled"
    :cancel-disabled="disabled"
    @ok.prevent="submit"
    class="in-form-modal"
    ok-title="ثبت"
    cancel-title="لغو"
    :agency="agency"
    id="product-change-quantity-modal"
    :title="
      type == 'increment'
        ? 'اضافه کردن به انبار' + agencyName
        : 'کم کردن از انبار' + agencyName
    "
    @hide
  >
    <b-form-input type="number" min="0" step="1" v-model.number="quantity" />
    <label for="des">توضیح</label>
    <b-form-textarea
        id="desc"
        name="description"
        v-model="description"
    ></b-form-textarea>
  </b-modal>
</template>

<script>
import { BFormInput, BFormTextarea, BModal } from "bootstrap-vue";

export default {
  name: "ProductChangeQuantity",
  components: { BFormInput, BFormTextarea , BModal },
  data() {
    return {
      description: '',
      disabled: false,
      quantity: 1,
    };
  },
  props: {
    type: String,
    variety: Object,
    agency: Number,
    quantity: Number,
    agencyName: String,
  },
  methods: {
    async submit() {
      try {
        this.disabled = true;
        const quantity = Math.max(0, Math.trunc(Number(this.quantity) || 0));
        const response = await this.$axios.post("admin/stores", {
          variety_id: this.variety.id,
          type: this.type,
          quantity,
          description: this.description,
          agency_id: this.agency,
        });
        this.$emit("getVarities");
        this.variety.quantity = Math.max(
          0,
          Math.trunc(Number(response.data.data.store.balance) || 0)
        );
        this.$root.$emit("bv::hide::modal", "product-change-quantity-modal");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>

<style scoped></style>
